/* eslint-disable react-hooks/exhaustive-deps */
import { useApolloClient } from "@apollo/client";
import { isEmpty } from "lodash";
import React, { useEffect } from "react";
import { useRecoilState } from "recoil";
import { getLatestVersionUser } from "../../graphql/query";
import { getMasterVersionUser } from "../../shared/atom/getDataMaster";

export default function Footer() {
  const client = useApolloClient();
  const [version, setVersion] = useRecoilState(getMasterVersionUser);

  useEffect(() => {
    if (isEmpty(version)) {
      getLatestVersionUser(client).then(setVersion);
    }
  }, []);

  return (
    <React.Fragment>
      <div className="container-fluid bg-white">
        <footer className="py-1 bg-white">
          <p className="foot text-center text-muted">
            &copy; Mostrans {new Date().getFullYear()}. All rights reserved |
            Version {version.version}
            {/* {"Copyright © "}
            {version.app} {new Date().getFullYear()}
            {"."} All rights reserved | Version {version.version} */}
          </p>
        </footer>
      </div>
    </React.Fragment>
  );
}
